import { useEffect, useState } from "react";

export function isMobileDeliveryDevice() {
    if (typeof window === "undefined") {
        return false;
    }

    const ua = navigator.userAgent;
    if (/Android.*Mobile|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
        return true;
    }

    return window.matchMedia("(max-width: 600px)").matches;
}

export function useIsMobileDeliveryDevice() {
    const [isMobile, setIsMobile] = useState(() => isMobileDeliveryDevice());

    useEffect(() => {
        const update = () => setIsMobile(isMobileDeliveryDevice());
        const mediaQuery = window.matchMedia("(max-width: 600px)");
        mediaQuery.addEventListener("change", update);
        window.addEventListener("resize", update);
        return () => {
            mediaQuery.removeEventListener("change", update);
            window.removeEventListener("resize", update);
        };
    }, []);

    return isMobile;
}
